import { useMemo } from 'react';

import type { StreamVideoPlayerType } from '@app/components/Chat/components/StreamVideoPlayer/types';
import { config } from '@app/config';
import { useUserPrint } from '@app/hooks';

import '@app/components/Chat/components/StreamVideoPlayer/styles/StreamVideoPlayer.desktop.scss';

export const StreamVideoPlayer: StreamVideoPlayerType = ({
  clientId,
  fileId,
}) => {
  const { database } = useUserPrint();
  const {
    backendHosts: { restHost },
  } = config;

  const src = useMemo(
    () =>
      `${restHost}/api/ClientFiles/Stream/${database}/${clientId}/${fileId}`,
    [database, restHost, clientId, fileId]
  );

  if (!clientId || !fileId) {
    return null;
  }

  return <video controls src={src} className="stream-video-player" />;
};
